import { GenericDeleteModal } from 'components/ui/GenericDeleteModal';
import { useTranslation } from 'react-i18next';

interface CancelConfigModalProps {
  open: boolean;
  onCancel: () => void;
  handleConfirm: () => void;
}

export const CancelConfigModal = ({
  open,
  onCancel,
  handleConfirm,
}: CancelConfigModalProps) => {
  const { t } = useTranslation();

  return (
    <GenericDeleteModal
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      bodyText={t('process-flow.configure.cancel-text')}
      okTitle={t('process-flow.configure.ok-text')}
    />
  );
};
